import {ReactNode} from 'react';
import {UserAccount} from '../__generated__/resolvers-types';
import LoadingPage from '../pages/other/LoadingPage';

export interface BranchRouteProps {
  user: UserAccount | null | undefined;
  privateRoute?: ReactNode;
  publicRoute?: ReactNode;
  userUndefinedLoading?: boolean;
}

export default function BranchRoute({user, privateRoute, publicRoute, userUndefinedLoading}: BranchRouteProps) {
  if (user === undefined && userUndefinedLoading) {
    return <LoadingPage />;
  }
  return user ? privateRoute : publicRoute;
}
